module.exports = __webpack_public_path__ + "img/2.4e95e2fd.png";